import { adminInstance } from "@/api/instance";

export default async function (reviewId) {
  return adminInstance.patch(`/review/${reviewId}`);
}
